import { getUser, getToken } from '@/services/userActions';
import store from '@/store';

export const checkUser = async (): Promise<string> => {
  try {
    await getToken();
    const user = await getUser();
    store.commit('SET_USER', user);
    return user?.role?.shortname;
  } catch (e) {
    return '';
  }
};
